import { Action } from 'redux'
import { InvoiceActions } from '../../reducers/invoice/actionNames'

const toggleInvoiceLoading = (toggle = false): IInvoiceToggleLoading => ({
  toggle,
  type: InvoiceActions.ToggleLoading,
})

export interface IInvoiceToggleLoading
  extends Action<InvoiceActions.ToggleLoading> {
  toggle?: boolean
}

export default toggleInvoiceLoading
